"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const specialNames_1 = __importDefault(require("./specialNames"));
const ContactInfo_1 = __importDefault(require("./ContactInfo"));
const IdentityInfo_1 = __importDefault(require("./IdentityInfo"));
const constants_1 = require("../constants");
class FedLeg {
    constructor(type, data) {
        this.API_ID = constants_1.parsePString(data?.id);
        this.in_office = data.in_office;
        this.firstName = constants_1.parsePString(data?.first_name);
        this.lastName = constants_1.parsePString(data?.last_name);
        this.middleName = constants_1.parsePString(data?.middle_name);
        this.fullName = specialNames_1.default?.[this.API_ID] ? specialNames_1.default[this.API_ID] : `${data?.first_name} ${data?.last_name}`;
        this.gender = constants_1.parsePString(data?.gender);
        this.party = parseParty(data?.party);
        this.image = `https://theunitedstates.io/images/congress/225x275/${data.id}.jpg`;
        this.identityInfo = new IdentityInfo_1.default(type, data.state, type === constants_1.LegislatorTypes.SENATE ? "" : data?.district, "", data?.geoid, null, data.id);
        this.contactInfo = new ContactInfo_1.default(constants_1.PersonTypes.FED_LEG, data);
        this.title = constants_1.parsePString(data?.title);
        this.short_title = constants_1.parsePString(data?.short_title);
        this.api_uri = constants_1.parsePString(data?.api_uri);
        this.govtrack_id = constants_1.parsePString(data?.govtrack_id);
        this.cspan_id = constants_1.parsePString(data?.cspan_id);
        this.votesmart_id = constants_1.parsePString(data?.votesmart_id);
        this.icpsr_id = constants_1.parsePString(data?.icpsr_id);
        this.crp_id = constants_1.parsePString(data?.crp_id);
        this.google_entity_id = constants_1.parsePString(data?.google_entity_id);
        this.state_rank = constants_1.parsePString(data?.state_rank);
        this.lis_id = constants_1.parsePString(data?.lis_id);
        this.suffix = constants_1.parsePString(data?.suffix);
        this.date_of_birth = constants_1.parsePString(data?.date_of_birth);
        this.leadership_role = constants_1.parsePString(data?.leadership_role);
        this.fec_candidate_id = constants_1.parsePString(data?.fec_candidate_id);
        this.cook_pvi = constants_1.parsePString(data?.cook_pvi);
        this.dw_nominate = constants_1.parsePString(data?.dw_nominate);
        this.ideal_point = constants_1.parsePString(data?.ideal_point);
        this.seniority = constants_1.parsePString(data?.seniority);
        this.next_election = constants_1.parsePString(data?.next_election);
        this.total_votes = constants_1.parsePString(data?.total_votes);
        this.missed_votes = constants_1.parsePString(data?.missed_votes);
        this.total_present = constants_1.parsePString(data?.total_present);
        this.last_updated = constants_1.parsePString(data?.last_updated);
        this.missed_votes_pct = constants_1.parsePString(data?.missed_votes_pct);
        this.votes_with_party_pct = constants_1.parsePString(data?.votes_with_party_pct);
        this.votes_against_party_pct = constants_1.parsePString(data?.votes_against_party_pct);
        this.ocd_id = constants_1.parsePString(data?.ocd_id);
        this.at_large = data.at_large;
        this.title = `${data.state} House Member`;
        if (type === constants_1.LegislatorTypes.SENATE) {
            this.title = `${data.state} Junior Senator`;
            if (data.state_rank === "senior")
                this.title = `${data.state} Senior Senator`;
            else if (data.state_rank === "junior")
                this.title = `${data.state} Junior Senator`;
        }
    }
}
exports.default = FedLeg;
function parseParty(unparsed) {
    if (unparsed === undefined)
        return null;
    if (unparsed === null)
        return null;
    unparsed = unparsed.toLowerCase();
    if (unparsed === "d")
        return constants_1.PartyEnum.Democrat;
    else if (unparsed === "r")
        return constants_1.PartyEnum.Republican;
    else if (unparsed === "id")
        return "Independent";
    else
        return unparsed;
}
